import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { LoginService } from '../../login/login.service';
import { CtbDiotService } from './ctb-diot.service';
import { AddDocService } from '../add-doc/add-doc.service';
import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';
import { PaginadorService, PageBusquedaObject } from '../../paginador/paginador.service';
import { title } from 'process';
import { PeriodoEjercicioService } from '../../control/periodo.service';

declare var $: any;
@Component({
  selector: 'app-ctb-diot',
  templateUrl: './ctb-diot.component.html',
  styleUrls: ['./ctb-diot.component.css'],
  providers: [CtbDiotService, AddDocService, PeriodoEjercicioService],
  preserveWhitespaces: true
})
export class CtbDiotComponent implements OnInit {

  busquedaPol: PageBusquedaObject = new PageBusquedaObject();
  totalItemsPol: number;
  rotatePol: any;
  public tpolList: any[] = [];
  itemsPol: any[];
  cfdi_options = [
    { value: '02', label: 'Enajenación de bienes' },
    { value: '03', label: 'Prestación de Servicios Profesionales' },
    { value: '06', label: 'Uso o goce temporal de bienes' },
    { value: '08', label: 'Importación por transferencia virtual' },
    { value: '85', label: 'Otros' }
  ];

  busquedaAddDoc: any = {};
  totalItemsAddDoc: number;
  desglose: any[] = [];
  camposAddDoc: any = [{ nombre: 'uuid', checked: true },
  { nombre: 'serie', checked: true },
  { nombre: 'folio', checked: true },
  { nombre: 'tipo', checked: true },
  { nombre: 'tipo_cfdi', checked: true },
  { nombre: 'fecha_emision', checked: true },
  { nombre: 'rfc_emisor', checked: true },
  { nombre: 'emisor', checked: false },
  { nombre: 'rfc_receptor', checked: true },
  { nombre: 'receptor', checked: false }];
  itemsAddDoc: any[];
  items: any[] = [];
  anos: any[] = [];
  items_tmp: any[] = [];
  lista_add_doc: any[] = [];
  indice_temp_cfdi_concepto: number = 0;
  indice_temp_cfdi_impto: number = 0;
  anio = 2021;
  mes = 1;
  indice = 0;
  elemento: any = { nombre: '', contenido: '' };
  ctb_diot_tmp: any = {};
  cargado: boolean;
  campos: any = [{ nombre: 'Tipo de tercero', checked: true },
  { nombre: 'Tipo de operación', checked: true },
  { nombre: 'Rfc', checked: true },
  { nombre: 'Numero de id fiscal', checked: false },
  { nombre: 'Nombre del extranjero', checked: false },
  { nombre: 'Pais de residencia', checked: false },
  { nombre: 'Nacionalidad', checked: false },
  { nombre: 'Valor de los actos o actividades pagados del 15% o 16% de IVA', checked: true },
  { nombre: 'Valor de los actos o actividades pagados al 15% de IVA', checked: false },
  { nombre: 'Monto del iva pagado no acreditable del 15% o 16% de iva', checked: false },
  { nombre: 'Valor de los actos o actividades pagados 10% u 11% de iva', checked: false },
  { nombre: 'Valor de los actos o actividades pagados al 10% de iva', checked: false },
  { nombre: 'Valor de los actos o actividades pagados sujeto al estimulo de la region frontera norte', checked: false },
  { nombre: 'Monto del iva pagado no acreditable 10% u 11% de iva', checked: false },
  { nombre: 'Monto del iva pagado no acreditable sujeto al estimulo de la region frontera norte', checked: false },
  { nombre: 'Valor de los actos o actividades pagados en importaciones', checked: false },

  { nombre: 'IVA pagado no acreditable por importaciones (15% o 16%)', checked: false },
  { nombre: 'Valor de los actos pagados en importación de bienes y servicios (15% o 16%)', checked: false },

  { nombre: 'IVA pagado no acreditable por importaciones (10% u 11%)', checked: false },
  { nombre: 'Valor de los actos pagados en importación de bienes y servicios (10% u 11%)', checked: false },

  { nombre: 'Valor de los actos o actividades pagados en la importación de bienes y servicios por los que no se pagará el IVA (Exentos)', checked: false },

  { nombre: 'Valor de los demas actos o actividades pagados a la tasa 0% de IVA', checked: false },
  { nombre: 'Valor de los actos pagados por los que no se pagará el IVA (EXCENTOS)', checked: false },
  { nombre: 'IVA retenido por el contribuyente', checked: false },
  { nombre: 'IVA correspondiente a las devoluciones, descuentos y bonificaciones sobre compras', checked: false }];
  constructor(private service: CtbDiotService, private PeriodoEjercicioService: PeriodoEjercicioService, private loginService: LoginService, private addDocService: AddDocService) { }

  ngOnInit(): void {
    this.indice = 0;
    
    this.inicializarBusqueda();
    
    this.PeriodoEjercicioService.periodo$
      .subscribe(periodo => {

        this.mes = periodo ? periodo : 12;
        if(this.mes == 13){
          this.mes = 12;
        }
      });
    this.cargarAnos();
  }
  cargarAnos() {
    const ejercicios = JSON.parse(localStorage.getItem('ejercicios'));
    for (let x = 0; x < ejercicios.length; x++) {
      this.anos.push(ejercicios[x].anio);
    }
    
             this.PeriodoEjercicioService.ejercicio$.subscribe(ejercicio => {
      this.anio = ejercicio ? ejercicio : 0;

    });
    this.datos();
  }
  cambiarTipoTercero(valor: any) {
    console.log(valor);
    if (valor == '04') {
      this.cfdi_options = [
        { value: '02', label: 'Enajenación de bienes' },
        { value: '03', label: 'Prestación de Servicios Profesionales' },
        { value: '06', label: 'Uso o goce temporal de bienes' },
        { value: '08', label: 'Importación por transferencia virtual' },
        { value: '85', label: 'Otros' }
      ];
      this.items[this.indice].tipo_operacion = '85';
    } else if (valor == '05') {
      this.cfdi_options = [
        { value: '02', label: 'Enajenación de bienes' },
        { value: '03', label: 'Prestación de Servicios Profesionales' },
        { value: '07', label: 'Importación de bienes o servicios' },
      ];
      this.items[this.indice].tipo_operacion = '07';
    }
    else if (valor == '15') {

      this.cfdi_options = [
        { value: '87', label: 'Operaciones globáles' }
      ];
      this.items[this.indice].tipo_operacion = '87';
    }
  }
  inicializarBusqueda() {
    this.busquedaAddDoc.criteriaSearch = {};
    this.busquedaAddDoc.criteriaSearch['tipoCfdi'] = 1;
    this.busquedaAddDoc.criteriaSearch['tipo'] = 'r';
    this.busquedaAddDoc.criteriaSearch['asociado'] = 0;
    this.busquedaAddDoc.itemsPerPage = 10;
    this.busquedaAddDoc.pageNumber = 0;

  }
  catalogoAddDoc() {
    this.busquedaAddDoc.criteriaSearch['gral_emp_id'] = this.loginService.empresa;
    this.addDocService.catalogo(this.busquedaAddDoc).subscribe(
      response => {
        this.itemsAddDoc = response.contenido.content;
        for (let x = 0; x < this.itemsAddDoc.length; x++) {
          this.itemsAddDoc[x].estatus_verificado = 1;
        }
        this.totalItemsAddDoc = response.contenido.totalElements;
      }, err => {
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        });
        console.log(err);
      });
  }
  cambiarPaginaAddDoc(event: any): void {
    this.busquedaAddDoc.pageNumber = event.page - 1;
    this.catalogoAddDoc();
  }
  filtroDeBusquedaAddDoc(find: any, columnName: any): void {
    this.busquedaAddDoc.criteriaSearch[columnName] = find;
  }
  sortearPorAddDoc(columnName: any): void {
    this.busquedaAddDoc.column = columnName;
    this.busquedaAddDoc.sort = true;
    this.busquedaAddDoc.pageNumber = 0;
    switch (this.busquedaAddDoc.order) {
      case 'desc':
        this.busquedaAddDoc.order = 'asc';
        break;
      default:
        this.busquedaAddDoc.order = 'desc';
        break;
    }
    this.catalogoAddDoc();
  }
  buscarEnCatalogoAddDoc(): void {
    this.busquedaAddDoc.itemsPerPage = 10;
    this.busquedaAddDoc.pageNumber = 0;
    if (this.busquedaAddDoc.criteriaSearch['fecha'] != null) {
      this.busquedaAddDoc.column = 'fecha';
      this.busquedaAddDoc.sort = true;
      this.busquedaAddDoc.pageNumber = 0;
      this.busquedaAddDoc.order = 'asc';
    }
    this.catalogoAddDoc();
  }
  limpiarBusquedaAddDoc(): void {
    setTimeout(() => {
      this.busquedaAddDoc.criteriaSearch = {};
      this.busquedaAddDoc.criteriaSearch['tipoCfdi'] = 1;
      this.busquedaAddDoc.criteriaSearch['tipo'] = 'r';
      this.busquedaAddDoc.criteriaSearch['asociado'] = 0;
      this.buscarEnCatalogoAddDoc();
    },
      50);
  }
  consultarAddDoc() {
    this.service.getAddDocByDiotId(this.items[this.indice].id).subscribe(
      response => {
        console.log(response);
        this.lista_add_doc = response.contenido;
        this.cerrarMensajeCarga();
      }, err => {
        this.cerrarMensajeCarga();
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        });
        console.log(err);
      });
  }
  descargarPdf(id: number) {
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Descargando...',
      timerProgressBar: true,
      showConfirmButton: false,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading();
        this.addDocService.getNombreContenidoById(id).subscribe(response => {
          this.elemento.nombre = response.nombre.replace('.xml', '');
          this.elemento.contenido = response.contenido;
          this.addDocService.descargaCfdiPdf(this.elemento).subscribe(response2 => {
            this.cerrarMensajeCarga();
            const a = document.createElement('a');
            a.href = URL.createObjectURL(response2);
            a.download = response.nombre.replace('.xml', '');
            document.body.appendChild(a);
            a.click();
          }, err2 => {
            this.cerrarMensajeCarga();
            const fr = new FileReader();

            fr.onload = (e) => {
              console.log(JSON.parse('' + e.target.result))
            };
            fr.readAsText(err2.error);
            if (err2.error.mensaje == null || '' || undefined) {
              err2.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
            }
            Swal.fire({
              icon: 'error',
              title: 'TNK Ledger',
              text: err2.error.mensaje
            });
          });
        }, err => {
          this.cerrarMensajeCarga();
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire({
            icon: 'error',
            title: 'TNK Ledger',
            text: err.error.mensaje
          });
          console.log(err);
        });
      }
    });

  }
  actualizarImpuesto(entity: any) {
    this.addDocService.putImpto(entity).subscribe(
      response => {
        this.datos();
        Swal.fire('TNK Ledger', response.mensaje, 'success');
      }, err => {
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        });
        console.log(err);
      });
  }
  datos() {
    this.items = [];
    this.items_tmp = [];
    this.mostrarMensajeCarga();
    this.service.get(this.loginService.empresa, this.mes, this.anio).subscribe(
      response => {
        this.cerrarMensajeCarga();
        this.items_tmp = response.contenido != null ? response.contenido : [];
        this.items = this.items_tmp.length > 0 ? this.items.concat(this.items_tmp.splice(0, 50)) : [];
        this.desglose = response.desglose;
        console.log(this.desglose);
      }, err => {
        this.cerrarMensajeCarga();
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        });
        console.log(err);
      });
  }
  mostrarInfo() {

  Swal.fire({
icon: 'warning',
title: 'Aviso de responsabilidad',
text: 'La información generada por este sistema se obtiene de manera automática a partir de los CFDI registrados y tiene carácter informativo. Es responsabilidad exclusiva del usuario revisar, validar y confirmar que los datos, cálculos y montos sean correctos antes de utilizarlos para cualquier trámite, declaración o presentación ante autoridades. El sistema no garantiza la exactitud o integridad de la información generada ni asume responsabilidad por errores, omisiones o diferencias derivadas de su uso.'
});


}

  guardar() {
    this.service.put(this.ctb_diot_tmp).subscribe(
      response => {
        this.cerrarMensajeCarga();
        Swal.fire({
          icon: 'success',
          title: 'TNK Ledger',
          text: response.mensaje
        });
        this.datos();
      }, err => {
        this.cerrarMensajeCarga();
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        });
        console.log(err);
      });
  }

  generarDiot() {



  }
  async generarDiotXlsx() {
    this.mostrarInfo();
    this.items = this.items.concat(this.items_tmp.splice(0, this.items_tmp.length + 1));
    console.log(this.items);
    // 1️⃣ Cargar template desde assets
    const response = await fetch('assets/template/PREDIOT.xlsx');
    const arrayBuffer = await response.arrayBuffer();

    // 2️⃣ Leer libro
    const workbook = XLSX.read(arrayBuffer, { type: 'array' });

    // 3️⃣ Obtener hojas
    let hoja1 = workbook.Sheets['prediot'];
    let hoja2 = workbook.Sheets['desglose_prediot'];
    //Definir datos de hoja 1 por medio de this.items


    /**
     * 
     * 
          diot += (cd.getTipo_tercero());
          diot += ("|");
          diot += (cd.getTipo_operacion());
          diot += ("|");
          diot += (cd.getRfc());
          diot += ("|");
          diot += (cd.getNumero_id_fiscal());
          diot += ("|");
          diot += (cd.getNombre_extranjero());
          diot += ("|");
          diot += (cd.getPais_residencia());
          diot += ("|");
          diot += (cd.getNacionalidad());
    
    
          //8
          //Este campo es precalculado Valor de los actos o actividades pagados sujeto al estimulo de la region frontera norte
          diot += ("|");
          diot += (cd.getVal_acts_act_pag_est_reg().compareTo(new BigDecimal(0)) == 0 ? ""
              : cd.getVal_acts_act_pag_est_reg().toString());
          diot += ("|");
    
    
          diot += ("|");
    
    
          diot += ("|");
    
    
          diot += ("|");
          //12
          //Este campo es precalculado Valor de los actos o actividades pagados del 15% o 16% de IVA
          diot += (cd.getVal_act_pag_del_15_16().compareTo(new BigDecimal(0)) == 0 ? ""
              : cd.getVal_act_pag_del_15_16().toString());
          diot += ("|");
          diot += ("|");
          diot += ("|");
          diot += ("|");
          diot += ("|");
          diot += ("|");
          diot += ("|");
          diot += ("|");
          diot += ("|");
          diot += ("|");
    
          //diot += (cd.getExcl_act_grav_total_16().compareTo(new BigDecimal(0)) == 0 ? ""
            //	: cd.getExcl_act_grav_total_16().toString());
          diot += ("|");
          diot += ("|");
          diot += ("|");
          diot += ("|");
          diot += ("|");
          diot += ("|");
          diot += ("|");
          diot += ("|");
          diot += ("|");
          diot += ("|");
          diot += ("|");
          diot += ("|");
          diot += ("|");
          diot += ("|");
          diot += ("|");
          diot += ("|");
          diot += ("|");
          diot += ("|");
          diot += ("|");
    
          diot += ("|");
          diot += ("|");
          diot += ("|");
          diot += ("|");
          diot += ("|");
          diot += ("|");
    
    
    
    
    
    
    
    
    
    
    
    
          //48
          //Este campo es precalculado IVA retenido por el contribuyente
          diot += ("|");
          diot += (cd.getIva_ret_contr().compareTo(new BigDecimal(0)) == 0 ? "" : cd.getIva_ret_contr().toString());
    
          diot += ("|");
    
    
          //50
          //Este campo es precalculado Valor de los actos pagados por los que no se pagará el IVA (EXCENTOS)
          diot += ("|");
          diot += (cd.getVal_act_pag_excento().compareTo(new BigDecimal(0)) == 0 ? ""
              : cd.getVal_act_pag_excento().toString());
    
    
    
    
    
          //51
          //Este campo es precalculado Valor de los demas actos o actividades pagados a la tasa 0% de IVA
          diot += ("|");
          diot += (cd.getVal_dem_acts_act_pag_0().compareTo(new BigDecimal(0)) == 0 ? ""
              : cd.getVal_dem_acts_act_pag_0().toString());
          diot += ("|");
          diot += ("|");
    
    
    
          diot += ("|");
          //54
          diot += ("01");
     */
    hoja1 = this.buildDiotXlsx(hoja1);
    hoja2 = this.buildDiotDesgloseXlsx(hoja2);


    // 5️⃣ Exportar archivo
    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    saveAs(new Blob([wbout]), 'PREDIOT_REVISION_'+(this.mes_a_nombre(this.mes)) + '_' + this.anio + '.xlsx');
  }
mes_a_nombre(mes: number): string {
  switch (mes) {
    case 1:
      return "ENERO";
    case 2:
      return "FEBRERO";
    case 3:
      return "MARZO";
    case 4:
      return "ABRIL";
    case 5:
      return "MAYO";
    case 6:
      return "JUNIO";
    case 7:
      return "JULIO";
    case 8:
      return "AGOSTO";
    case 9:
      return "SEPTIEMBRE";
    case 10:
      return "OCTUBRE";
    case 11:
      return "NOVIEMBRE";
    case 12:
      return "DICIEMBRE";
    default:
      return "Mes inválido";
  }
}
  estiloTituloXlsx(hoja: any, fila: number, columnas: number, color: String): any{
        const rango = XLSX.utils.decode_range(hoja['!ref']);
//Pintar 53 columnas
    for (let x = 0; x <= columnas; x++) {

      const cellRef = XLSX.utils.encode_cell({ r: fila, c: x }); // fila 1 = índice 0

      if (!hoja[cellRef]) {
        hoja[cellRef] = { t: 's', v: '' };
      }

      hoja[cellRef].s = {
        font: { bold: true },
        fill: {
          patternType: "solid",
          fgColor: { rgb: color } // amarillo
        }
      };
    }
    return hoja;
  }

  //DIOT COMO TAL
  buildDiotXlsx(hoja1: any): any {

    hoja1 = this.estiloTituloXlsx(hoja1,0,53,"FFFF00");

    hoja1['!cols'] = [
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 20 },
      { wch: 60 }
    ];

    let filaInicial = 2;

    this.items.forEach((item, index) => {
      let fila = filaInicial + index;

      hoja1[`A${fila}`] = { t: 's', v: item.tipo_tercero };
      hoja1[`B${fila}`] = { t: 's', v: item.tipo_operacion };
      hoja1[`C${fila}`] = { t: 's', v: item.rfc };
      hoja1[`D${fila}`] = { t: 's', v: item.numero_id_fiscal };
      hoja1[`E${fila}`] = { t: 's', v: item.nombre_extranjero };
      hoja1[`F${fila}`] = { t: 's', v: item.pais_residencia };
      hoja1[`G${fila}`] = { t: 's', v: item.nacionalidad };
      //Este campo es precalculado Valor de los actos o actividades pagados sujeto al estimulo de la region frontera norte

      hoja1[`H${fila}`] = { t: 's', v: item.val_acts_act_pag_est_reg == 0 ? '' : item.val_acts_act_pag_est_reg };
      hoja1[`I${fila}`] = { t: 's', v: '' };
      hoja1[`J${fila}`] = { t: 's', v: '' };
      hoja1[`K${fila}`] = { t: 's', v: '' };

      hoja1[`L${fila}`] = { t: 's', v: item.val_act_pag_del_15_16 == 0 ? '' : item.val_act_pag_del_15_16 };
      hoja1[`M${fila}`] = { t: 's', v: item.iva_corr_sobr_compr == 0 ? '' : item.iva_corr_sobr_compr };
      hoja1[`N${fila}`] = { t: 's', v: '' };
      hoja1[`O${fila}`] = { t: 's', v: '' };
      hoja1[`P${fila}`] = { t: 's', v: '' };
      hoja1[`Q${fila}`] = { t: 's', v: '' };
      hoja1[`R${fila}`] = { t: 's', v: '' };
      hoja1[`S${fila}`] = { t: 's', v: '' };
      hoja1[`T${fila}`] = { t: 's', v: '' };
      hoja1[`U${fila}`] = { t: 's', v: '' };
      hoja1[`V${fila}`] = { t: 's', v: '' };
      hoja1[`W${fila}`] = { t: 's', v: '' };

      hoja1[`X${fila}`] = { t: 's', v: '' };
      hoja1[`Y${fila}`] = { t: 's', v: '' };
      hoja1[`Z${fila}`] = { t: 's', v: '' };
      hoja1[`AA${fila}`] = { t: 's', v: '' };
      hoja1[`AB${fila}`] = { t: 's', v: '' };
      hoja1[`AC${fila}`] = { t: 's', v: '' };
      hoja1[`AD${fila}`] = { t: 's', v: '' };
      hoja1[`AE${fila}`] = { t: 's', v: '' };
      hoja1[`AF${fila}`] = { t: 's', v: '' };
      hoja1[`AG${fila}`] = { t: 's', v: '' };
      hoja1[`AH${fila}`] = { t: 's', v: '' };
      hoja1[`AI${fila}`] = { t: 's', v: '' };
      hoja1[`AJ${fila}`] = { t: 's', v: '' };
      hoja1[`AK${fila}`] = { t: 's', v: '' };
      hoja1[`AL${fila}`] = { t: 's', v: '' };
      hoja1[`AM${fila}`] = { t: 's', v: '' };
      hoja1[`AN${fila}`] = { t: 's', v: '' };
      hoja1[`AO${fila}`] = { t: 's', v: '' };
      hoja1[`AP${fila}`] = { t: 's', v: '' };
      hoja1[`AQ${fila}`] = { t: 's', v: '' };
      hoja1[`AR${fila}`] = { t: 's', v: '' };
      hoja1[`AS${fila}`] = { t: 's', v: '' };
      hoja1[`AT${fila}`] = { t: 's', v: '' };
      hoja1[`AU${fila}`] = { t: 's', v: '' };
      hoja1[`AV${fila}`] = { t: 's', v: item.iva_ret_contr == 0 ? '' : item.iva_ret_contr };
      hoja1[`AW${fila}`] = { t: 's', v: '' };
      hoja1[`AX${fila}`] = { t: 's', v: item.val_act_pag_excento == 0 ? '' : item.val_act_pag_excento };
      hoja1[`AY${fila}`] = { t: 's', v: item.val_dem_acts_act_pag_0 == 0 ? '' : item.val_dem_acts_act_pag_0 };
      hoja1[`AZ${fila}`] = { t: 's', v: '' };
      hoja1[`BA${fila}`] = { t: 's', v: '' };
      hoja1[`BB${fila}`] = { t: 's', v: '01' };

      // fila es la fila actual donde quieres poner la fórmula
      hoja1[`BD${fila}`] = {
        t: 's',
        f: `=CONCATENATE(A${fila},"|",B${fila},"|",C${fila},"|",D${fila},"|",E${fila},"|",F${fila},"|",G${fila},"|",H${fila},"|",I${fila},"|",J${fila},"|",K${fila},"|",L${fila},"|",M${fila},"|",N${fila},"|",O${fila},"|",P${fila},"|",Q${fila},"|",R${fila},"|",S${fila},"|",T${fila},"|",U${fila},"|",V${fila},"|",W${fila},"|",X${fila},"|",Y${fila},"|",Z${fila},"|",AA${fila},"|",AB${fila},"|",AC${fila},"|",AD${fila},"|",AE${fila},"|",AF${fila},"|",AG${fila},"|",AH${fila},"|",AI${fila},"|",AJ${fila},"|",AK${fila},"|",AL${fila},"|",AM${fila},"|",AN${fila},"|",AO${fila},"|",AP${fila},"|",AQ${fila},"|",AR${fila},"|",AS${fila},"|",AT${fila},"|",AU${fila},"|",AV${fila},"|",AW${fila},"|",AX${fila},"|",AY${fila},"|",AZ${fila},"|",BA${fila},"|",BB${fila})`
        , v: ''
      };
    });
    const ultimaFila = filaInicial + this.items.length - 1;
    hoja1['!ref'] = `A1:BG${ultimaFila}`;
    return hoja1;
  }



  //DIOT DESGLOSADO
  buildDiotDesgloseXlsx(hoja2: any): any {

    hoja2['!cols'] = [
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 60 },
      { wch: 20 },
      { wch: 60 }
    ];

    let fila = 0;

    this.desglose.forEach((item, index) => {
      fila = fila + 5;

      hoja2[`A${fila}`] = { t: 's', v: '01 - Tipo de tercero' };
      hoja2[`B${fila}`] = { t: 's', v: '02 -Tipo de operación' };
      hoja2[`C${fila}`] = { t: 's', v: '03 - RFC' };
      hoja2[`D${fila}`] = { t: 's', v: '04 - ID Fiscal' };
      hoja2[`E${fila}`] = { t: 's', v: '05 - Nombre del Extranjero' };
      hoja2[`F${fila}`] = { t: 's', v: '06 - País de residencia' };
      hoja2[`G${fila}`] = { t: 's', v: '07- Jurisdicción Fiscal' };
      //Este campo es precalculado Valor de los actos o actividades pagados sujeto al estimulo de la region frontera norte

      hoja2[`H${fila}`] = { t: 's', v: '08 - Actividades pagadas RFN' };
      hoja2[`I${fila}`] = { t: 's', v: '09 - Devoluciones, Descuentos y Bonificaciones RFN' };
      hoja2[`J${fila}`] = { t: 's', v: '10 - Actividades pagadas RFS' };
      hoja2[`K${fila}`] = { t: 's', v: '11 - Devoluciones, Descuentos y Bonificaciones RFS' };

      hoja2[`L${fila}`] = { t: 's', v: '12 - Actividades pagadas Resto del país' };
      hoja2[`M${fila}`] = { t: 's', v: '13 - Devoluciones, Descuentos y Bonificaciones Resto del país' };
      hoja2[`N${fila}`] = { t: 's', v: '14 - Importaciones 16%' };
      hoja2[`O${fila}`] = { t: 's', v: '15 - Devoluciones, Descuentos y Bonificaciones en Importaciones' };
      hoja2[`P${fila}`] = { t: 's', v: '16 - Importaciones Intangibles 16%' };
      hoja2[`Q${fila}`] = { t: 's', v: '17 - Devoluciones, Descuentos y Bonificaciones en Importaciones Intangibles' };
      hoja2[`R${fila}`] = { t: 's', v: '18 - IVA Acreditable Pagado Frontera Norte' };
      hoja2[`S${fila}`] = { t: 's', v: '19 - Proporción de actividades pagadas Frontera Norte' };
      hoja2[`T${fila}`] = { t: 's', v: '20 - IVA Acreditable Pagado Frontera Sur' };
      hoja2[`U${fila}`] = { t: 's', v: '21- Proporción de actividades pagadas Frontera Sur' };
      hoja2[`V${fila}`] = { t: 's', v: '22 - IVA Acreditable Pagado Resto del País' };
      hoja2[`W${fila}`] = { t: 's', v: '23- Proporción de actividades pagadas Resto del País' };

      hoja2[`X${fila}`] = { t: 's', v: '24- IVA Acreditable Pagado Importación Tangibles' };
      hoja2[`Y${fila}`] = { t: 's', v: '25- Proporción de actividades pagadas Importación Tangibles' };
      hoja2[`Z${fila}`] = { t: 's', v: '26- IVA Acreditable Pagado Importación Intangibles' };
      hoja2[`AA${fila}`] = { t: 's', v: '27- Proporción de actividades pagadas Importación Intangibles' };
      hoja2[`AB${fila}`] = { t: 's', v: '28-  IVA no acreditable - Proporción de actividades pagadas 16% RFN' };
      hoja2[`AC${fila}`] = { t: 's', v: '29- IVA No Acreditable - Actividades que no cumplen requisitos fiscales RFN' };
      hoja2[`AD${fila}`] = { t: 's', v: '30-  IVA No Acreditable - Actividades Exentas RFN' };
      hoja2[`AE${fila}`] = { t: 's', v: '31 - IVA No Acreditable - Actividades No Objeto RFN' };
      hoja2[`AF${fila}`] = { t: 's', v: '32 - IVA no acreditable - Proporción de actividades pagadas 16% RFS' };
      hoja2[`AG${fila}`] = { t: 's', v: '33 - IVA No Acreditable - Actividades que no cumplen requisitos fiscales RFS' };
      hoja2[`AH${fila}`] = { t: 's', v: '34-  IVA No Acreditable - Actividades Exentas RFS' };
      hoja2[`AI${fila}`] = { t: 's', v: '35 -IVA No Acreditable - Actividades No Objeto RFS' };
      hoja2[`AJ${fila}`] = { t: 's', v: '36 - IVA no acreditable - Proporción de actividades pagadas 16% Resto del país' };
      hoja2[`AK${fila}`] = { t: 's', v: '37- IVA No Acreditable - Actividades que no cumplen requisitos fiscales Resto del país' };
      hoja2[`AL${fila}`] = { t: 's', v: '38 - IVA No Acreditable - Actividades Exentas Resto del país' };
      hoja2[`AM${fila}`] = { t: 's', v: '39 - IVA No Acreditable - Actividades No Objeto Resto del país' };
      hoja2[`AN${fila}`] = { t: 's', v: '40 - IVA no acreditable - Proporción de actividades pagadas 16% Importación Tangibles' };
      hoja2[`AO${fila}`] = { t: 's', v: '41 - IVA No Acreditable - Actividades que no cumplen requisitos fiscales Importación Tangibles' };
      hoja2[`AP${fila}`] = { t: 's', v: '42 - IVA No Acreditable - Actividades Exentas Importación Tangibles' };
      hoja2[`AQ${fila}`] = { t: 's', v: '43 - IVA No Acreditable - Actividades No Objeto Importación Tangibles' };
      hoja2[`AR${fila}`] = { t: 's', v: '44 -  IVA no acreditable - Proporción de actividades pagadas 16% Importación Intangibles' };
      hoja2[`AS${fila}`] = { t: 's', v: '45 - IVA No Acreditable - Actividades que no cumplen requisitos fiscales Importación Intangibles' };
      hoja2[`AT${fila}`] = { t: 's', v: '46 - IVA No Acreditable - Actividades Exentas Importación Intangibles' };
      hoja2[`AU${fila}`] = { t: 's', v: '47 - IVA No Acreditable - Actividades No Objeto Importación Intangibles' };
      hoja2[`AV${fila}`] = { t: 's', v: '48 - IVA Retenido POR el contribuyente' };
      hoja2[`AW${fila}`] = { t: 's', v: '49 - Valor de los actos o actividades en la importación exentos' };
      hoja2[`AX${fila}`] = { t: 's', v: '50 - Valor de actos o actividades exentos' };
      hoja2[`AY${fila}`] = { t: 's', v: '51 - Valor de actos o actividades 0%' };
      hoja2[`AZ${fila}`] = { t: 's', v: '52 -Valor de actos o actividades no objeto en territorio nacional' };
      hoja2[`BA${fila}`] = { t: 's', v: '53 - Valor de actos o actividades no objeto sin establecimiento en territorio nacional' };
      hoja2[`BB${fila}`] = { t: 's', v: '54 - Efectos fiscales a los comprobantes de operaciones realizadas con el proveedor' };


       hoja2 = this.estiloTituloXlsx(hoja2,fila-1,53,"FFFF00");


       fila = fila + 1;

      hoja2[`A${fila}`] = { t: 's', v: item.ctb_diot.tipo_tercero };
      hoja2[`B${fila}`] = { t: 's', v: item.ctb_diot.tipo_operacion };
      hoja2[`C${fila}`] = { t: 's', v: item.ctb_diot.rfc };
      hoja2[`D${fila}`] = { t: 's', v: item.ctb_diot.numero_id_fiscal };
      hoja2[`E${fila}`] = { t: 's', v: item.ctb_diot.nombre_extranjero };
      hoja2[`F${fila}`] = { t: 's', v: item.ctb_diot.pais_residencia };
      hoja2[`G${fila}`] = { t: 's', v: item.ctb_diot.nacionalidad };
      //Este campo es precalculado Valor de los actos o actividades pagados sujeto al estimulo de la region frontera norte

      hoja2[`H${fila}`] = { t: 's', v: item.ctb_diot.val_acts_act_pag_est_reg == 0 ? '' : item.ctb_diot.val_acts_act_pag_est_reg };
      hoja2[`I${fila}`] = { t: 's', v: '' };
      hoja2[`J${fila}`] = { t: 's', v: '' };
      hoja2[`K${fila}`] = { t: 's', v: '' };

      hoja2[`L${fila}`] = { t: 's', v: item.ctb_diot.val_act_pag_del_15_16 == 0 ? '' : item.ctb_diot.val_act_pag_del_15_16 };
      hoja2[`M${fila}`] = { t: 's', v: item.ctb_diot.iva_corr_sobr_compr == 0 ? '' : item.ctb_diot.iva_corr_sobr_compr };
      hoja2[`N${fila}`] = { t: 's', v: '' };
      hoja2[`O${fila}`] = { t: 's', v: '' };
      hoja2[`P${fila}`] = { t: 's', v: '' };
      hoja2[`Q${fila}`] = { t: 's', v: '' };
      hoja2[`R${fila}`] = { t: 's', v: '' };
      hoja2[`S${fila}`] = { t: 's', v: '' };
      hoja2[`T${fila}`] = { t: 's', v: '' };
      hoja2[`U${fila}`] = { t: 's', v: '' };
      hoja2[`V${fila}`] = { t: 's', v: '' };
      hoja2[`W${fila}`] = { t: 's', v: '' };

      hoja2[`X${fila}`] = { t: 's', v: '' };
      hoja2[`Y${fila}`] = { t: 's', v: '' };
      hoja2[`Z${fila}`] = { t: 's', v: '' };
      hoja2[`AA${fila}`] = { t: 's', v: '' };
      hoja2[`AB${fila}`] = { t: 's', v: '' };
      hoja2[`AC${fila}`] = { t: 's', v: '' };
      hoja2[`AD${fila}`] = { t: 's', v: '' };
      hoja2[`AE${fila}`] = { t: 's', v: '' };
      hoja2[`AF${fila}`] = { t: 's', v: '' };
      hoja2[`AG${fila}`] = { t: 's', v: '' };
      hoja2[`AH${fila}`] = { t: 's', v: '' };
      hoja2[`AI${fila}`] = { t: 's', v: '' };
      hoja2[`AJ${fila}`] = { t: 's', v: '' };
      hoja2[`AK${fila}`] = { t: 's', v: '' };
      hoja2[`AL${fila}`] = { t: 's', v: '' };
      hoja2[`AM${fila}`] = { t: 's', v: '' };
      hoja2[`AN${fila}`] = { t: 's', v: '' };
      hoja2[`AO${fila}`] = { t: 's', v: '' };
      hoja2[`AP${fila}`] = { t: 's', v: '' };
      hoja2[`AQ${fila}`] = { t: 's', v: '' };
      hoja2[`AR${fila}`] = { t: 's', v: '' };
      hoja2[`AS${fila}`] = { t: 's', v: '' };
      hoja2[`AT${fila}`] = { t: 's', v: '' };
      hoja2[`AU${fila}`] = { t: 's', v: '' };
      hoja2[`AV${fila}`] = { t: 's', v: item.ctb_diot.iva_ret_contr == 0 ? '' : item.ctb_diot.iva_ret_contr };
      hoja2[`AW${fila}`] = { t: 's', v: '' };
      hoja2[`AX${fila}`] = { t: 's', v: item.ctb_diot.val_act_pag_excento == 0 ? '' : item.ctb_diot.val_act_pag_excento };
      hoja2[`AY${fila}`] = { t: 's', v: item.ctb_diot.val_dem_acts_act_pag_0 == 0 ? '' : item.ctb_diot.val_dem_acts_act_pag_0 };
      hoja2[`AZ${fila}`] = { t: 's', v: '' };
      hoja2[`BA${fila}`] = { t: 's', v: '' };
      hoja2[`BB${fila}`] = { t: 's', v: '01' };

        
      //Este es el desglose del add_doc
      item.add_doc.forEach((item: any, index: any) => {
        fila = fila + 1;

      hoja2[`A${fila}`] = { t: 's', v: 'UUID' };
      hoja2[`B${fila}`] = { t: 's', v: 'Serie + Folio' };
      hoja2[`C${fila}`] = { t: 's', v: 'Clase' };
      hoja2[`D${fila}`] = { t: 's', v: 'Tipo de CFDI' };
      hoja2[`E${fila}`] = { t: 's', v: 'Fecha' };
      hoja2[`F${fila}`] = { t: 's', v: 'Total' };
      hoja2[`G${fila}`] = { t: 's', v: '' };
      //Este campo es precalculado Valor de los actos o actividades pagados sujeto al estimulo de la region frontera norte

      hoja2[`H${fila}`] = { t: 's', v: '' };
      hoja2[`I${fila}`] = { t: 's', v: '' };
      hoja2[`J${fila}`] = { t: 's', v: '' };
      hoja2[`K${fila}`] = { t: 's', v: '' };

      hoja2[`L${fila}`] = { t: 's', v: '' };
      hoja2[`M${fila}`] = { t: 's', v: '' };
      hoja2[`N${fila}`] = { t: 's', v: '' };
      hoja2[`O${fila}`] = { t: 's', v: '' };
      hoja2[`P${fila}`] = { t: 's', v: '' };
      hoja2[`Q${fila}`] = { t: 's', v: '' };
      hoja2[`R${fila}`] = { t: 's', v: '' };
      hoja2[`S${fila}`] = { t: 's', v: '' };
      hoja2[`T${fila}`] = { t: 's', v: '' };
      hoja2[`U${fila}`] = { t: 's', v: '' };
      hoja2[`V${fila}`] = { t: 's', v: '' };
      hoja2[`W${fila}`] = { t: 's', v: '' };

      hoja2[`X${fila}`] = { t: 's', v: '' };
      hoja2[`Y${fila}`] = { t: 's', v: '' };
      hoja2[`Z${fila}`] = { t: 's', v: '' };
      hoja2[`AA${fila}`] = { t: 's', v: '' };
      hoja2[`AB${fila}`] = { t: 's', v: '' };
      hoja2[`AC${fila}`] = { t: 's', v: '' };
      hoja2[`AD${fila}`] = { t: 's', v: '' };
      hoja2[`AE${fila}`] = { t: 's', v: '' };
      hoja2[`AF${fila}`] = { t: 's', v: '' };
      hoja2[`AG${fila}`] = { t: 's', v: '' };
      hoja2[`AH${fila}`] = { t: 's', v: '' };
      hoja2[`AI${fila}`] = { t: 's', v: '' };
      hoja2[`AJ${fila}`] = { t: 's', v: '' };
      hoja2[`AK${fila}`] = { t: 's', v: '' };
      hoja2[`AL${fila}`] = { t: 's', v: '' };
      hoja2[`AM${fila}`] = { t: 's', v: '' };
      hoja2[`AN${fila}`] = { t: 's', v: '' };
      hoja2[`AO${fila}`] = { t: 's', v: '' };
      hoja2[`AP${fila}`] = { t: 's', v: '' };
      hoja2[`AQ${fila}`] = { t: 's', v: '' };
      hoja2[`AR${fila}`] = { t: 's', v: '' };
      hoja2[`AS${fila}`] = { t: 's', v: '' };
      hoja2[`AT${fila}`] = { t: 's', v: '' };
      hoja2[`AU${fila}`] = { t: 's', v: '' };
      hoja2[`AV${fila}`] = { t: 's', v: '' };
      hoja2[`AW${fila}`] = { t: 's', v: '' };
      hoja2[`AX${fila}`] = { t: 's', v: '' };
      hoja2[`AY${fila}`] = { t: 's', v: '' };
      hoja2[`AZ${fila}`] = { t: 's', v: '' };
      hoja2[`BA${fila}`] = { t: 's', v: '' };
      hoja2[`BB${fila}`] = { t: 's', v: '' };

        
       hoja2 = this.estiloTituloXlsx(hoja2,fila-1,53,"00aae4");
        
        fila = fila + 1;

        hoja2[`A${fila}`] = { t: 's', v: item.uuid };
        hoja2[`B${fila}`] = { t: 's', v: item.serie + item.folio };
        hoja2[`C${fila}`] = { t: 's', v: item.tipo == 'r' ? 'Recibido' : 'Emitido' };
        let tipo_cfdi = '';
        switch (item.tipo_cfdi) {
          case 1:
            tipo_cfdi = 'Ingreso';
            break;
          case 2:
            tipo_cfdi = 'Egreso (Nota de Crédito)';
            break;
          case 3:

            tipo_cfdi = 'Pago (Complemento de Pago)';
            break;
        }
        hoja2[`D${fila}`] = { t: 's', v: tipo_cfdi };
        let fecha = new Date(item.fecha_crea);

let fecha_formateada =
  fecha.getFullYear() + '-' +
  String(fecha.getMonth() + 1).padStart(2, '0') + '-' +
  String(fecha.getDate()).padStart(2, '0');
        hoja2[`E${fila}`] = { t: 's', v: fecha_formateada };
        hoja2[`F${fila}`] = { t: 's', v: item.total };
        

        hoja2[`G${fila}`] = { t: 's', v: '' };
        //Este campo es precalculado Valor de los actos o actividades pagados sujeto al estimulo de la region frontera norte

        hoja2[`H${fila}`] = { t: 's', v: '' };
        hoja2[`I${fila}`] = { t: 's', v: '' };
        hoja2[`J${fila}`] = { t: 's', v: '' };
        hoja2[`K${fila}`] = { t: 's', v: '' };

        hoja2[`L${fila}`] = { t: 's', v: '' };
        hoja2[`M${fila}`] = { t: 's', v: '' };
        hoja2[`N${fila}`] = { t: 's', v: '' };
        hoja2[`O${fila}`] = { t: 's', v: '' };
        hoja2[`P${fila}`] = { t: 's', v: '' };
        hoja2[`Q${fila}`] = { t: 's', v: '' };
        hoja2[`R${fila}`] = { t: 's', v: '' };
        hoja2[`S${fila}`] = { t: 's', v: '' };
        hoja2[`T${fila}`] = { t: 's', v: '' };
        hoja2[`U${fila}`] = { t: 's', v: '' };
        hoja2[`V${fila}`] = { t: 's', v: '' };
        hoja2[`W${fila}`] = { t: 's', v: '' };

        hoja2[`X${fila}`] = { t: 's', v: '' };
        hoja2[`Y${fila}`] = { t: 's', v: '' };
        hoja2[`Z${fila}`] = { t: 's', v: '' };
        hoja2[`AA${fila}`] = { t: 's', v: '' };
        hoja2[`AB${fila}`] = { t: 's', v: '' };
        hoja2[`AC${fila}`] = { t: 's', v: '' };
        hoja2[`AD${fila}`] = { t: 's', v: '' };
        hoja2[`AE${fila}`] = { t: 's', v: '' };
        hoja2[`AF${fila}`] = { t: 's', v: '' };
        hoja2[`AG${fila}`] = { t: 's', v: '' };
        hoja2[`AH${fila}`] = { t: 's', v: '' };
        hoja2[`AI${fila}`] = { t: 's', v: '' };
        hoja2[`AJ${fila}`] = { t: 's', v: '' };
        hoja2[`AK${fila}`] = { t: 's', v: '' };
        hoja2[`AL${fila}`] = { t: 's', v: '' };
        hoja2[`AM${fila}`] = { t: 's', v: '' };
        hoja2[`AN${fila}`] = { t: 's', v: '' };
        hoja2[`AO${fila}`] = { t: 's', v: '' };
        hoja2[`AP${fila}`] = { t: 's', v: '' };
        hoja2[`AQ${fila}`] = { t: 's', v: '' };
        hoja2[`AR${fila}`] = { t: 's', v: '' };
        hoja2[`AS${fila}`] = { t: 's', v: '' };
        hoja2[`AT${fila}`] = { t: 's', v: '' };
        hoja2[`AU${fila}`] = { t: 's', v: '' };
        hoja2[`AV${fila}`] = { t: 's', v: '' };
        hoja2[`AW${fila}`] = { t: 's', v: '' };
        hoja2[`AX${fila}`] = { t: 's', v: '' };
        hoja2[`AY${fila}`] = { t: 's', v: '' };
        hoja2[`AZ${fila}`] = { t: 's', v: '' };
        hoja2[`BA${fila}`] = { t: 's', v: '' };
        hoja2[`BB${fila}`] = { t: 's', v: '' };



console.log("item", item);
const impuestos = item.NC ==null? item.PUE_COMP_PAG:item.NC;
console.log("Impuestos", impuestos);

if(impuestos){
   fila = fila + 1;

        hoja2[`A${fila}`] = { t: 's', v: 'Tipo' };
        hoja2[`B${fila}`] = { t: 's', v: 'Base' };
        hoja2[`C${fila}`] = { t: 's', v: 'Clave Impuesto' };
        hoja2[`D${fila}`] = { t: 's', v: 'Tipo Factor' };
        hoja2[`E${fila}`] = { t: 's', v: 'Tasa o Cuota' };
        

        hoja2[`F${fila}`] = { t: 's', v: 'Importe' };
        hoja2[`G${fila}`] = { t: 's', v: '' };
        //Este campo es precalculado Valor de los actos o actividades pagados sujeto al estimulo de la region frontera norte

        hoja2[`H${fila}`] = { t: 's', v: '' };
        hoja2[`I${fila}`] = { t: 's', v: '' };
        hoja2[`J${fila}`] = { t: 's', v: '' };
        hoja2[`K${fila}`] = { t: 's', v: '' };

        hoja2[`L${fila}`] = { t: 's', v: '' };
        hoja2[`M${fila}`] = { t: 's', v: '' };
        hoja2[`N${fila}`] = { t: 's', v: '' };
        hoja2[`O${fila}`] = { t: 's', v: '' };
        hoja2[`P${fila}`] = { t: 's', v: '' };
        hoja2[`Q${fila}`] = { t: 's', v: '' };
        hoja2[`R${fila}`] = { t: 's', v: '' };
        hoja2[`S${fila}`] = { t: 's', v: '' };
        hoja2[`T${fila}`] = { t: 's', v: '' };
        hoja2[`U${fila}`] = { t: 's', v: '' };
        hoja2[`V${fila}`] = { t: 's', v: '' };
        hoja2[`W${fila}`] = { t: 's', v: '' };

        hoja2[`X${fila}`] = { t: 's', v: '' };
        hoja2[`Y${fila}`] = { t: 's', v: '' };
        hoja2[`Z${fila}`] = { t: 's', v: '' };
        hoja2[`AA${fila}`] = { t: 's', v: '' };
        hoja2[`AB${fila}`] = { t: 's', v: '' };
        hoja2[`AC${fila}`] = { t: 's', v: '' };
        hoja2[`AD${fila}`] = { t: 's', v: '' };
        hoja2[`AE${fila}`] = { t: 's', v: '' };
        hoja2[`AF${fila}`] = { t: 's', v: '' };
        hoja2[`AG${fila}`] = { t: 's', v: '' };
        hoja2[`AH${fila}`] = { t: 's', v: '' };
        hoja2[`AI${fila}`] = { t: 's', v: '' };
        hoja2[`AJ${fila}`] = { t: 's', v: '' };
        hoja2[`AK${fila}`] = { t: 's', v: '' };
        hoja2[`AL${fila}`] = { t: 's', v: '' };
        hoja2[`AM${fila}`] = { t: 's', v: '' };
        hoja2[`AN${fila}`] = { t: 's', v: '' };
        hoja2[`AO${fila}`] = { t: 's', v: '' };
        hoja2[`AP${fila}`] = { t: 's', v: '' };
        hoja2[`AQ${fila}`] = { t: 's', v: '' };
        hoja2[`AR${fila}`] = { t: 's', v: '' };
        hoja2[`AS${fila}`] = { t: 's', v: '' };
        hoja2[`AT${fila}`] = { t: 's', v: '' };
        hoja2[`AU${fila}`] = { t: 's', v: '' };
        hoja2[`AV${fila}`] = { t: 's', v: '' };
        hoja2[`AW${fila}`] = { t: 's', v: '' };
        hoja2[`AX${fila}`] = { t: 's', v: '' };
        hoja2[`AY${fila}`] = { t: 's', v: '' };
        hoja2[`AZ${fila}`] = { t: 's', v: '' };
        hoja2[`BA${fila}`] = { t: 's', v: '' };
        hoja2[`BB${fila}`] = { t: 's', v: '' };



        
       hoja2 = this.estiloTituloXlsx(hoja2,fila-1,53,"ff7b5a");
          //Este es el desglose del impuesto
      impuestos.forEach((item: any, index: any) => {
        
        
        fila = fila + 1;

        hoja2[`A${fila}`] = { t: 's', v: item.tipo == 't'? 'Traslado':'Retención' };
        hoja2[`B${fila}`] = { t: 's', v: item.base!=null?item.base:item.base_p };
        hoja2[`C${fila}`] = { t: 's', v: item.impuesto!=null?item.impuesto:item.impuesto_p };
        hoja2[`D${fila}`] = { t: 's', v: item.tipo_factor!=null?item.tipo_factor:item.tipo_factor_p };
        hoja2[`E${fila}`] = { t: 's', v: item.tasa_o_cuota!=null?item.tasa_o_cuota:item.tasa_o_cuota_p };
        

        hoja2[`F${fila}`] = { t: 's', v: item.importe!=null?item.importe:item.importe_p };
        hoja2[`G${fila}`] = { t: 's', v: '' };
        //Este campo es precalculado Valor de los actos o actividades pagados sujeto al estimulo de la region frontera norte

        hoja2[`H${fila}`] = { t: 's', v: '' };
        hoja2[`I${fila}`] = { t: 's', v: '' };
        hoja2[`J${fila}`] = { t: 's', v: '' };
        hoja2[`K${fila}`] = { t: 's', v: '' };

        hoja2[`L${fila}`] = { t: 's', v: '' };
        hoja2[`M${fila}`] = { t: 's', v: '' };
        hoja2[`N${fila}`] = { t: 's', v: '' };
        hoja2[`O${fila}`] = { t: 's', v: '' };
        hoja2[`P${fila}`] = { t: 's', v: '' };
        hoja2[`Q${fila}`] = { t: 's', v: '' };
        hoja2[`R${fila}`] = { t: 's', v: '' };
        hoja2[`S${fila}`] = { t: 's', v: '' };
        hoja2[`T${fila}`] = { t: 's', v: '' };
        hoja2[`U${fila}`] = { t: 's', v: '' };
        hoja2[`V${fila}`] = { t: 's', v: '' };
        hoja2[`W${fila}`] = { t: 's', v: '' };

        hoja2[`X${fila}`] = { t: 's', v: '' };
        hoja2[`Y${fila}`] = { t: 's', v: '' };
        hoja2[`Z${fila}`] = { t: 's', v: '' };
        hoja2[`AA${fila}`] = { t: 's', v: '' };
        hoja2[`AB${fila}`] = { t: 's', v: '' };
        hoja2[`AC${fila}`] = { t: 's', v: '' };
        hoja2[`AD${fila}`] = { t: 's', v: '' };
        hoja2[`AE${fila}`] = { t: 's', v: '' };
        hoja2[`AF${fila}`] = { t: 's', v: '' };
        hoja2[`AG${fila}`] = { t: 's', v: '' };
        hoja2[`AH${fila}`] = { t: 's', v: '' };
        hoja2[`AI${fila}`] = { t: 's', v: '' };
        hoja2[`AJ${fila}`] = { t: 's', v: '' };
        hoja2[`AK${fila}`] = { t: 's', v: '' };
        hoja2[`AL${fila}`] = { t: 's', v: '' };
        hoja2[`AM${fila}`] = { t: 's', v: '' };
        hoja2[`AN${fila}`] = { t: 's', v: '' };
        hoja2[`AO${fila}`] = { t: 's', v: '' };
        hoja2[`AP${fila}`] = { t: 's', v: '' };
        hoja2[`AQ${fila}`] = { t: 's', v: '' };
        hoja2[`AR${fila}`] = { t: 's', v: '' };
        hoja2[`AS${fila}`] = { t: 's', v: '' };
        hoja2[`AT${fila}`] = { t: 's', v: '' };
        hoja2[`AU${fila}`] = { t: 's', v: '' };
        hoja2[`AV${fila}`] = { t: 's', v: '' };
        hoja2[`AW${fila}`] = { t: 's', v: '' };
        hoja2[`AX${fila}`] = { t: 's', v: '' };
        hoja2[`AY${fila}`] = { t: 's', v: '' };
        hoja2[`AZ${fila}`] = { t: 's', v: '' };
        hoja2[`BA${fila}`] = { t: 's', v: '' };
        hoja2[`BB${fila}`] = { t: 's', v: '' };

      });
    }





      });







    });
    const ultimaFila = fila + this.items.length - 1;
    hoja2['!ref'] = `A1:BG${ultimaFila}`;
    return hoja2;
  }

  validarNumerosLista() {
    for (let x = 0; x < this.items.length; x++) {
      this.items[x].val_act_pag_del_15_16 = (this.items[x].val_act_pag_del_15_16 !== '' ? this.items[x].val_act_pag_del_15_16 : 0);
      this.items[x].val_act_pag_15 = (this.items[x].val_act_pag_15 !== '' ? this.items[x].val_act_pag_15 : 0);
      this.items[x].mon_iva_no_acr = (this.items[x].mon_iva_no_acr !== '' ? this.items[x].mon_iva_no_acr : 0);
      this.items[x].val_acts_act_pag_10_u_11 =
        (this.items[x].val_acts_act_pag_10_u_11 !== '' ? this.items[x].val_acts_act_pag_10_u_11 : 0);
      this.items[x].val_acts_act_pag_10 =
        (this.items[x].val_acts_act_pag_10 !== '' ? this.items[x].val_acts_act_pag_10 : 0);
      this.items[x].val_acts_act_pag_est_reg =
        (this.items[x].val_acts_act_pag_est_reg !== '' ? this.items[x].val_acts_act_pag_est_reg : 0);
      this.items[x].mon_iva_pag_no_acr = (this.items[x].mon_iva_pag_no_acr !== '' ? this.items[x].mon_iva_pag_no_acr : 0);
      this.items[x].mon_iva_pag_no_acr_reg = (this.items[x].mon_iva_pag_no_acr_reg !== '' ? this.items[x].mon_iva_pag_no_acr_reg : 0);
      this.items[x].val_acts_act_pag_import = (this.items[x].val_acts_act_pag_import !== '' ? this.items[x].val_acts_act_pag_import : 0);
      this.items[x].iva_pag_no_acr_import = (this.items[x].iva_pag_no_acr_import !== '' ? this.items[x].iva_pag_no_acr_import : 0);
      this.items[x].val_acts_pag_import_b_s = (this.items[x].val_acts_pag_import_b_s !== '' ? this.items[x].val_acts_pag_import_b_s : 0);
      this.items[x].val_dem_acts_act_pag_0 = (this.items[x].val_dem_acts_act_pag_0 !== '' ? this.items[x].val_dem_acts_act_pag_0 : 0);
      this.items[x].val_act_pag_excento = (this.items[x].val_act_pag_excento !== '' ? this.items[x].val_act_pag_excento : 0);
      this.items[x].iva_ret_contr = (this.items[x].iva_ret_contr !== '' ? this.items[x].iva_ret_contr : 0);
      this.items[x].iva_corr_sobr_compr = (this.items[x].iva_corr_sobr_compr !== '' ? this.items[x].iva_corr_sobr_compr : 0);
    }
  }

  generateExcel() {
    const rows = this.items.map(obj => [
      obj.rfc,
      (obj.val_act_pag_del_15_16).toFixed(2),
      (obj.val_act_pag_15).toFixed(2),
      (obj.iva_pag_no_acr_import_15_o_16).toFixed(2),
      (obj.val_acts_act_pag_10_u_11).toFixed(2),
      (obj.val_acts_act_pag_10).toFixed(2),
      (obj.iva_pag_no_acr_import_10_u_11).toFixed(2),
      (obj.val_acts_act_pag_est_reg).toFixed(2),
      (obj.mon_iva_pag_no_acr_reg).toFixed(2),
      (obj.val_acts_act_pag_import).toFixed(2),
      (obj.iva_pag_no_acr_import_15_o_16).toFixed(2),
      (obj.val_acts_pag_import_b_s).toFixed(2),
      (obj.val_dem_acts_act_pag_0).toFixed(2),
      (obj.val_act_pag_excento).toFixed(2),
      (obj.iva_ret_contr).toFixed(2),
      (obj.iva_corr_sobr_compr).toFixed(2)
    ]);

    // Obtener los nombres de las columnas
    const headers = [
      'RFC',
      'Valor de los actos o actividades pagados del 15% o 16% de IVA',
      'Valor de los actos o actividades pagados al 15% de IVA',
      'Monto del IVA pagado no acreditable del 15% o 16% de IVA',
      'Valor de los actos o actividades pagados 10% u 11% de IVA',
      'Valor de los actos o actividades pagados al 10% de IVA',
      'Monto del IVA pagado no acreditable 10% u 11% de IVA',
      'Valor de los actos o actividades pagados sujeto al estímulo de la región fronteriza norte',
      'Monto del IVA pagado no acreditable sujeto al estímulo de la región fronteriza norte',
      'Valor de los actos o actividades pagados en importaciones',
      'IVA pagado no acreditable por importaciones (15% o 16%)',
      'Valor de los actos pagados en importación de bienes y servicios (15% o 16%)',
      'Valor de los demás actos o actividades pagados a la tasa 0% de IVA',
      'Valor de los actos pagados por los que no se pagará el IVA (EXCENTOS)',
      'IVA retenido por el contribuyente',
      'IVA correspondiente a las devoluciones, descuentos y bonificaciones sobre compras'
    ];

    // Calcular la longitud máxima de cada columna
    const columnWidths = headers.map((header, index) => ({
      wch: header.length > 10 ? header.length : 10 // Establecer un ancho mínimo de 10 para cada columna
    }));
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);

    ws['!cols'] = columnWidths;
    XLSX.utils.book_append_sheet(wb, ws, 'Datos');

    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const fileName: string = this.loginService.usuario.empresa_seleccionada.titulo + ' IVA DESGLOSADO POR RFC.xlsx';
    this.saveExcelFile(excelBuffer, fileName);
  }

  saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: 'application/octet-stream' });
    saveAs(data, fileName);
  }



  setIndice(indice: number) {
    this.showNotification('Verifica y modifica la información según sea necesario.');

    this.indice = indice;
    this.ctb_diot_tmp = this.items[this.indice];
    this.consultarAddDoc();
  }
  deshacerCambios() {
    // console.log('Cambio desecho');
    // console.log(this.ctb_diot_tmp);
    //this.datos();
  }
  cargarMas() {
    this.mostrarMensajeCarga();
    this.items = this.items.concat(this.items_tmp.splice(0, 50));
    this.cerrarMensajeCarga();
  }
  mostrarMensajeCarga() {
    this.cargado = false;
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Procesando...',
      timerProgressBar: true,
      showConfirmButton: false,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      }
    });
  }
  cerrarMensajeCarga() {
    this.cargado = true;
    Swal.close();
  }




  showNotification(mensaje: any) {

    $.notify({
      icon: 'pe-7s-info',
      message: mensaje
    }, {
      type: 'info',
      timer: 1000,
      placement: {
        from: 'top',
        align: 'center'
      }
    });
  }
}
